var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useCallback, useState } from 'react';
import { ChatBoxConfirmationDialog } from '../design_system/ChatBoxConfirmationDialog';
import { useTranslation } from 'react-i18next';
import { LineOfBusinessesBrandingColors } from '../constants/lineOfBusinessesBrandingColors';
import { green157 } from '@spotify-internal/encore-foundation';
import { useLineOfBusiness } from '../hooks/useLineOfBusiness';
import { useCloseConfirmationDialogStore } from '../stores/closeConfirmationDialogStore';
import { useConversationClosed, useConversationRestarted, } from '../stores/conversationStateStore';
import { useCloseConversation } from '../hooks/useCloseConversation';
import { useShowChatboxStore } from '../stores/showChatboxStore';
import { useEventStore } from '../stores/eventStore';
export const CloseConfirmationDialogController = () => {
    var _a, _b;
    const { t } = useTranslation();
    const { lineOfBusiness } = useLineOfBusiness();
    const { isOpen, setIsOpen } = useCloseConfirmationDialogStore();
    const { hasClosed, setHasClosed } = useConversationClosed();
    const { setHasRestarted } = useConversationRestarted();
    const closeConversation = useCloseConversation();
    const [, setShowChatbox] = useShowChatboxStore(lineOfBusiness);
    const { setEvents } = useEventStore();
    const [isWaitingForClose, setIsWaitingForClose] = useState(false);
    const buttonHoverBackgroundColor = ((_a = LineOfBusinessesBrandingColors[lineOfBusiness]) === null || _a === void 0 ? void 0 : _a.buttonHoverBackgroundColor) || green157;
    const buttonHoverTextColor = ((_b = LineOfBusinessesBrandingColors[lineOfBusiness]) === null || _b === void 0 ? void 0 : _b.buttonHoverTextColor) ||
        '#fff';
    const handleDialogSubmit = useCallback((response) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            if (response === 'confirm') {
                setIsWaitingForClose(true);
                setHasRestarted(false);
                setHasClosed(true);
                const closed = yield closeConversation();
                if (!closed || hasClosed) {
                    setEvents([]);
                    setHasClosed(false);
                    setHasRestarted(false);
                    setShowChatbox(false);
                }
            }
        }
        finally {
            setIsWaitingForClose(false);
            setIsOpen(false);
        }
    }), [
        closeConversation,
        hasClosed,
        setEvents,
        setHasClosed,
        setHasRestarted,
        setIsOpen,
        setIsWaitingForClose,
        setShowChatbox,
    ]);
    return (React.createElement(ChatBoxConfirmationDialog, { title: t('ARE_YOU_SURE_TO_END_CONVERSATION_TEXT'), declineLabel: t('CONTINUE_CONVERSATION_TEXT'), confirmLabel: t('CLOSE_TEXT'), onSubmit: handleDialogSubmit, isOpen: isOpen, isWaitingForClose: isWaitingForClose, hoverBackgroundColor: buttonHoverBackgroundColor, hoverTextColor: buttonHoverTextColor }));
};
